import { AppVersion } from "@/components/Common/AppVersion";
import { FOOTER_HEIGHT_PX } from "@/lib/layout";

export const Footer = () => {
  return (
    <footer
      className="z-20 flex flex-row justify-between border-t border-t-primary bg-white px-2 text-xs"
      // Applied for the same reason as the header's height: see WEBV3-256.
      style={{ height: FOOTER_HEIGHT_PX }}
    >
      <div>ShopHero Dashboard</div>
      <div className="flex-grow"></div>
      <AppVersion />
    </footer>
  );
};
